module.exports = __webpack_public_path__ + "files/b6a3668ba47701c7040e7cebd34e4a6e.png";